import { RESET_LAST_ITEM } from 'bento-ordering/cart/constants/actionTypes';

export const resetLastItem = () => ({ type: RESET_LAST_ITEM });
